import { Icons } from "./icons";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import "./navbar-spacing.css";

const C = {
  bg: "#0a0a0f", bg2: "#111118",
  surface: "rgba(255,255,255,0.04)", surfaceHover: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.08)", borderHover: "rgba(255,255,255,0.14)",
  text: "#f5f5f7", secondary: "rgba(245,245,247,0.55)", tertiary: "rgba(245,245,247,0.30)",
  accent: "#0a84ff", accentBg: "rgba(10,132,255,0.12)",
  green: "#30d158", greenBg: "rgba(48,209,88,0.1)",
  orange: "#ff9f0a", purple: "#bf5af2", red: "#ff453a",
};

const SECTIONS = [
  { title: "Locali", items: [
    { label: "Crea locale",      path: "/adminlocali",      color: C.green,  icon: "menu" },
    { label: "Visualizza tutti", path: "/visualizzalocali", color: C.accent, icon: "eye" },
    { label: "Genera QR Code",   path: "/qr-generator",     color: C.orange, icon: "qr" },
  ]},
  { title: "Utenti & Accessi", items: [
    { label: "Gestione utenti",  path: "/gestione-utenti",      color: C.purple, icon: "training" },
    { label: "Registra utente",  path: "/registrazione-utente", color: C.accent, icon: "users" },
    {
      label: "Analytics accessi",
      path: "/analytics-accessi",
      color: C.orange,
      icon: "table"
    },
  ]},
  { title: "Revenue", items: [
    { label: "Sponsor Hub",      path: "/sponsor",           color: C.orange, icon: "tag" },
    { label: "Gestione sponsor", path: "/gestione-sponsor",  color: C.green,  icon: "settings" },
    { label: "Report admin",     path: "/report-admin",      color: C.accent, icon: "table" },
  ]},
  {
  title: "Demo",
  items: [
    {
      label: "Gestione Demo",
      path: "/gestione-demo",
      color: C.orange,
      icon: "ai"
    },
    {
      label: "Lead Demo",
      path: "/demo-leads",
      color: C.green,
      icon: "users"
    }
  ]
}, 

  { title: "Operazioni", items: [
    { label: "Ordini",          path: "/ordersdashboard", color: C.green,  icon: "ordini" },
    { label: "Gestione banner", path: "/gestione-banner", color: C.purple, icon: "category" },
    { label: "AI Console",      path: "/ai",              color: C.accent, icon: "ai" },
  ]},
];

function StatCard({ label, value, sub, color, loading }) {
  return (
    <div style={{ flex: "1 1 150px", background: C.surface, border: `1px solid ${C.border}`, borderRadius: 20, padding: "1.25rem 1.2rem", transition: "background 220ms ease, border-color 220ms ease" }}
      onMouseEnter={e => { e.currentTarget.style.background = C.surfaceHover; e.currentTarget.style.borderColor = C.borderHover; }}
      onMouseLeave={e => { e.currentTarget.style.background = C.surface; e.currentTarget.style.borderColor = C.border; }}
    >
      <p style={{ margin: "0 0 0.5rem", fontSize: "0.72rem", color: C.secondary, fontWeight: 500 }}>{label}</p>
      <p style={{ margin: "0 0 0.2rem", fontSize: "2rem", fontWeight: 700, letterSpacing: "-1px", color: loading ? C.tertiary : color, lineHeight: 1 }}>
        {loading ? "—" : value}
      </p>
      {sub && <p style={{ margin: 0, fontSize: "0.65rem", color: C.tertiary }}>{sub}</p>}
    </div>
  );
}

function NavPill({ label, path }) {
  const navigate = useNavigate();
  return (
    <button onClick={() => navigate(path)} style={{ padding: "0.45rem 0.95rem", background: C.surface, border: `1px solid ${C.border}`, borderRadius: 999, color: C.text, fontSize: "0.78rem", fontWeight: 500, cursor: "pointer", whiteSpace: "nowrap", transition: "background 160ms ease", fontFamily: "inherit" }}
      onMouseEnter={e => e.currentTarget.style.background = C.surfaceHover}
      onMouseLeave={e => e.currentTarget.style.background = C.surface}
    >{label}</button>
  );
}

function Section({ title, items }) {
  return (
    <div>
      <p style={{ margin: "0 0 0.6rem 0.2rem", fontSize: "0.68rem", color: C.secondary, fontWeight: 600, letterSpacing: "0.6px", textTransform: "uppercase" }}>{title}</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(128px, 1fr))", gap: "0.55rem" }}>
        {items.map((item, i) => {
          const Icon = Icons[item.icon];
          return (
            <Link key={i} to={item.path} style={{ textDecoration: "none" }}>
              <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 18, padding: "1rem 0.9rem", cursor: "pointer", transition: "all 200ms ease" }}
                onMouseEnter={e => { e.currentTarget.style.background = C.surfaceHover; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.borderColor = item.color + "40"; }}
                onMouseLeave={e => { e.currentTarget.style.background = C.surface; e.currentTarget.style.transform = ""; e.currentTarget.style.borderColor = C.border; }}
              >
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.6rem"
                }}>
                  {Icon && <Icon color={item.color} />}
                  <span style={{
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    color: C.text,
                    lineHeight: 1.35,
                    textAlign: "center"
                  }}>
                    {item.label}
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default function DashboardAdmin() {
  const [stats, setStats] = useState({ locali: 0, utenti: 0, ordini: 0, incassoOggi: 0 });
  const [loading, setLoading] = useState(true);
  const [now, setNow] = useState(new Date());

  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const [localiSnap, utentiSnap, ordiniSnap] = await Promise.all([getDocs(collection(db, "locali")), getDocs(collection(db, "utenti")), getDocs(collection(db, "ordini"))]);
        const oggi = new Date(); oggi.setHours(0, 0, 0, 0);
        const incassoOggi = ordiniSnap.docs.map(d => d.data()).filter(o => o.stato === "pagato" && o.timestamp?.seconds && new Date(o.timestamp.seconds * 1000) >= oggi).reduce((s, o) => s + (o.totale || 0), 0);
        setStats({ locali: localiSnap.size, utenti: utentiSnap.size, ordini: ordiniSnap.size, incassoOggi });
      } catch (e) { console.error(e); } finally { setLoading(false); }
    };
    load();
  }, []);

  const timeStr = now.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
  const dateStr = now.toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });

  return (
    <>
      <div style={{ minHeight: "100vh", background: C.bg, fontFamily: "-apple-system, 'SF Pro Display', 'Helvetica Neue', sans-serif", color: C.text }}>
        <div className="page-with-navbar" style={{ maxWidth: 960, margin: "0 auto" }}>

          {/* Header */}
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem", marginBottom: "2.5rem" }}>
            <div>
              <p style={{ margin: "0 0 0.25rem", fontSize: "0.75rem", color: C.secondary, fontWeight: 500 }}>Pannello di controllo</p>
              <h1 style={{ margin: 0, fontSize: "clamp(1.5rem, 3vw, 2rem)", fontWeight: 700, letterSpacing: "-0.5px" }}>Dashboard Admin</h1>
            </div>
            <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 16, padding: "0.85rem 1.25rem", textAlign: "right" }}>
              <div style={{ fontSize: "1.5rem", fontWeight: 300, letterSpacing: "2px", fontVariantNumeric: "tabular-nums" }}>{timeStr}</div>
              <div style={{ fontSize: "0.68rem", color: C.tertiary, marginTop: "0.15rem", textTransform: "capitalize" }}>{dateStr}</div>
            </div>
          </div>

          {/* Stats */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.7rem", marginBottom: "1.75rem" }}>
            <StatCard label="Locali attivi"  value={stats.locali}   color={C.accent}  loading={loading} />
            <StatCard label="Utenti"         value={stats.utenti}   color={C.purple}  loading={loading} />
            <StatCard label="Ordini totali"  value={stats.ordini}   color={C.green}   loading={loading} />
            <StatCard label="Incasso oggi"   value={`€${stats.incassoOggi.toFixed(0)}`} color={C.orange} loading={loading} sub="ordini pagati" />
          </div>

          {/* Quick access */}
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "0.5rem", padding: "0.85rem 1rem", background: C.surface, border: `1px solid ${C.border}`, borderRadius: 16, marginBottom: "2rem" }}>
            <span style={{ fontSize: "0.68rem", color: C.tertiary, fontWeight: 600, letterSpacing: "0.5px", textTransform: "uppercase", marginRight: "0.25rem" }}>Rapido</span>
            {[{label:"Nuovo locale",path:"/adminlocali"},{label:"Demo",path:"/gestione-demo"},{label:"Genera QR",path:"/qr-generator"},{label:"Ordini",path:"/ordersdashboard"},{label:"Report",path:"/report-admin"},{label:"AI",path:"/ai"}].map((a,i)=><NavPill key={i} {...a} />)}
          </div>

          {/* Sections */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "1.75rem" }}>
            {SECTIONS.map((s, i) => <Section key={i} {...s} />)}
          </div>

          {/* Footer status */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", marginTop: "2.5rem", paddingTop: "1.5rem", borderTop: `1px solid ${C.border}` }}>
            {[{label:"Sistema operativo",c:C.green},{label:"Firebase connesso",c:C.green},{label:`${stats.locali} locali`,c:C.accent}].map((s,i)=>(
              <div key={i} style={{ display:"flex", alignItems:"center", gap:"0.4rem", fontSize:"0.7rem", color:C.secondary }}>
                <span style={{ width:6, height:6, borderRadius:"50%", background:s.c, display:"inline-block" }} />
                {s.label}
              </div>
            ))}
          </div>

        </div>
      </div>
    </>
  );
}
